const MANIFEST_JS = {
  accordion: {
    hashed: 'accordion.5df10a0a000bef7823367b49e1ebc438.min.js',
    versioned: 'accordion.min.js'
  },
  alertBox: {
    hashed: 'alert-box.59c5c15fc3f789a64155ba4d88a701c3.min.js',
    versioned: 'alert-box.min.js'
  },
  core: {
    hashed: 'core.5c823f40992688bfc63a8946d7d6ada9.min.js',
    versioned: 'core.min.js'
  },
  modalDialog: {
    hashed: 'modal-dialog.026aec34ce3d8a974c8e223b30d5fc94.min.js',
    versioned: 'modal-dialog.min.js'
  },
  popover: {
    hashed: 'popover.c0bb859225ba9cf9b10f7c64f56a7c6d.min.js',
    versioned: 'popover.min.js'
  },
  progress: {
    hashed: 'progress.cb7a7169a756e16f9d614bc132652abf.min.js',
    versioned: 'progress.min.js'
  },
  progressiveImage: {
    hashed: 'progressive-image.29ea6583979203bad0a99f05b2fe2218.min.js',
    versioned: 'progressive-image.min.js'
  },
  tabs: {
    hashed: 'tabs.b3e468e7a69c62561caf815744cbfccf.min.js',
    versioned: 'tabs.min.js'
  },
  toggleSwitch: {
    hashed: 'toggle-switch.b959553da98ffd9165e17db01e5b22d5.min.js',
    versioned: 'toggle-switch.min.js'
  }
};
export { MANIFEST_JS };